module.exports = __webpack_public_path__ + "static/img/IconAI-coral.6a20f204.svg";